export const RouterLinks = {
   Login: '/',
   Registrarse: '/registrarse',
   Home: '/pv',
   HistoriaClinica: '/pv/HistoriaClinica',
   InformacionPersonal: '/pv/FormInformacionPersonal',
   Consentimiento: '/pv/FormConsentimiento',
   Antecedentes: '/pv/FormAntecedentes',
   EvaluacionSaludBucal: '/pv/FormEvaluacionSaludBucal',
   PlacaBacteriana: '/pv/FormPlacaBacteriana',
   CariesDental: '/pv/FormCariesDental',
   EvaluacionRiesgo: '/pv/FormEvaluacionRiesgo',
   CarnetFluorizacion: '/pv/FormCarnetFluorizacion'
}

export const urlApi = " https://saludoralprimerainfanciaicbf.col1.co/api"
// export const urlApi = " http://192.168.1.29:3132"